// import mapはShopifyが先行して読み込むmoduleスクリプトの影響でFirefoxでは無効になるため、URL直接importにする
import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.165.0/build/three.module.js';

const $body = document.body;
const $norenOpening = document.querySelector('.noren-opening');
const $topVisualSlide = document.querySelector('.top-visual-slide');
const topVisualSlide = () => {
  if ($topVisualSlide) {
    let option = {
      type: 'loop',
      focus: 'left',
      fixedWidth: '93.33333333vw',
      gap: 0,
      autoScroll: {
        speed: 1.0,
        pauseOnHover: false
      },
      arrows: false,
      pagination: false,
      drag: false,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          fixedWidth: '50vw',
          gap: 0
        }
      }
    };
    new Splide($topVisualSlide, option).mount(window.splide.Extensions);
  }
};

const OPENING_STORAGE_KEY = 'tamasushi-opening-finished';
const hasOpeningFinished = (() => {
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'reload') return false; // リロード時は必ず再生する
    return sessionStorage.getItem(OPENING_STORAGE_KEY) === '1';
  } catch (e) { return false; }
})();

if ($norenOpening && hasOpeningFinished) {
  // 同一セッションで再生済み：アニメーションせず即スキップ
  $norenOpening.classList.add('is-finished', 'is-hidden');
  $body.classList.add('body-opening-finished');
  document.dispatchEvent(new CustomEvent('noren-opening:end'));
  topVisualSlide();
} else if ($norenOpening) {
  const $noren = $norenOpening.querySelector('.noren-opening-noren');
  const $imgs = $noren.querySelectorAll('img');

  // ===== 設定 =====
  const OPEN_DELAY = 500;    // 読み込み完了からめくれ開始までの時間(ms)
  const OPEN_DURATION = 1200; // 開きの時間(ms)
  const FADE_DURATION = 400;  // 白背景フェードの時間(ms)

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // オープニング表示中はスクロールを止める
  document.documentElement.style.overflow = 'hidden';

  let clothRunning = true;
  let liftProgress = 0; // めくれ中に布へ加える追い風(0-1)
  let norenLiftY = 0;   // 終盤にのれん自体を上へ移動させるオフセット(px)

  const renderedW = () => $noren.clientWidth;
  const renderedH = () => $noren.clientHeight;

  const textureLoader = new THREE.TextureLoader();
  const scene = new THREE.Scene();

  const camera = new THREE.OrthographicCamera(
    -renderedW() / 2, renderedW() / 2,
    renderedH() / 2, -renderedH() / 2,
    1, 1000
  );
  camera.position.z = 500;

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(renderedW(), renderedH());
  $noren.appendChild(renderer.domElement);

  const $canvas = $noren.querySelector('canvas');

  // 寸法は可変にする（リサイズで更新）
  // 画像の実寸比率（opening_noren1-3.png）を維持する
  const ASPECTS = [1130 / 1518, 1130 / 1518, 1123 / 1518];
  // 各画像内で布が不透明に存在する左右範囲（0-1）。隣り合う布同士を隙間なく接続するために使う
  const SOLID = [
    [0.0735, 0.9858],
    [0.0142, 0.9788],
    [0.0080, 0.9101]
  ];
  let PANEL_H = renderedH();
  const TOP_Y = 0;

  const colors = [0xffffff, 0xffffff, 0xffffff];

  // テクスチャは一度だけ読み込んでキャッシュ（リサイズ時の再ロードを防ぐ）
  const textures = [];
  const texturePromises = []; // 読み込み完了を待つためのPromise

  let panels = [];

  const createPanel = (index, width, centerX) => {
    const geometry = new THREE.PlaneGeometry(width, PANEL_H, 20, 28);

    if (!textures[index]) {
      const src = $imgs[index].getAttribute('src');
      texturePromises[index] = new Promise((resolve, reject) => {
        const texture = textureLoader.load(src, resolve, undefined, reject);
        texture.colorSpace = THREE.SRGBColorSpace;
        textures[index] = texture;
      });
    }

    const material = new THREE.MeshBasicMaterial({
      map: textures[index],
      transparent: true,
      color: colors[index],
      side: THREE.DoubleSide
    });

    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.x = centerX;
    mesh.position.y = TOP_Y;
    scene.add(mesh);

    panels.push({
      mesh,
      geometry,
      material,
      basePositions: geometry.attributes.position.array.slice(),
      width,
      index
    });
  }

  const buildPanels = () => {
    // サイズが取れないタイミング（レイアウト前・リサイズ中）では何もしない
    // （0除算でジオメトリがNaNになり描画が止まるのを防ぐ。サイズ確定後にResizeObserverが再実行する）
    if (!renderedW() || !renderedH()) return;

    // 既存パネルを破棄
    panels.forEach(p => {
      scene.remove(p.mesh);
      p.geometry.dispose();
      p.material.dispose();
    });
    panels = [];

    // 現在の寸法で再計算（高さ基準・画像比率維持）
    PANEL_H = renderedH();
    const widths = ASPECTS.map(a => PANEL_H * a);

    // 布の不透明範囲同士が接するよう左端座標を算出
    let L1 = -widths[1] / 2; // 中央パネル（仮位置）
    let L0 = L1 + SOLID[1][0] * widths[1] - SOLID[0][1] * widths[0];
    let L2 = L1 + SOLID[1][1] * widths[1] - SOLID[2][0] * widths[2];

    // 布全体の中心を画面中央へ
    const solidLeft = L0 + SOLID[0][0] * widths[0];
    const solidRight = L2 + SOLID[2][1] * widths[2];
    const shift = -(solidLeft + solidRight) / 2;

    createPanel(0, widths[0], L0 + widths[0] / 2 + shift);
    createPanel(1, widths[1], L1 + widths[1] / 2 + shift);
    createPanel(2, widths[2], L2 + widths[2] / 2 + shift);

    // テクスチャ3枚の読み込み完了後に img → canvas に切り替える
    // （読み込み前に切り替えるとThree.jsが空テクスチャ＝黒でパネルを描画し黒画面になる）
    Promise.all(texturePromises).then(() => {
      if (!panels.length) return;
      $imgs.forEach($img => ($img.style.opacity = 0));
      $canvas.style.opacity = 1;
    }).catch(() => {
      // 読み込み失敗時はimg表示のまま（クリップアニメーションは動くので演出は継続する）
    });
  }

  buildPanels();

  // 位相をずらす（暖簾ごとに開始タイミング・速度を変える）
  let time = Math.random() * 100;
  const speedFactor = 0.9 + Math.random() * 0.2;

  const easePulse = t => {
    const cycle = t % 5.5;
    if (cycle > 1.25) return 0;
    const x = cycle / 1.25;
    return Math.sin(x * Math.PI);
  }

  const animate = () => {
    if (!clothRunning) return;
    requestAnimationFrame(animate);
    time += 0.016 * speedFactor;

    const baseWind = Math.sin(time * 1.2) * 0.5 + 0.5;
    const liftPulse = easePulse(time);

    panels.forEach((panel) => {
      panel.mesh.position.y = TOP_Y + norenLiftY;

      const pos = panel.geometry.attributes.position;
      const arr = pos.array;
      const base = panel.basePositions;

      for (let i = 0; i < arr.length; i += 3) {
        const x = base[i];
        const y = base[i + 1];

        const u = (x + panel.width / 2) / panel.width;
        const v = 1 - ((y + PANEL_H / 2) / PANEL_H);

        const bottomPower = Math.pow(v, 2.2);
        const rightPower = Math.pow(u, 2.4);

        const panelDelay = panel.index * 0.35;
        const wave = Math.sin(time * 2.2 + u * 3.5 + panelDelay) * 5;

        let dx = wave * bottomPower * (0.25 + panel.index * 0.25);
        let dy = Math.sin(time * 1.7 + u * 2.5) * 4 * bottomPower;

        if (panel.index === 2) {
          const lift = (baseWind * 0.18 + liftPulse * 1.0) * bottomPower * rightPower;
          dy += lift * 110;
          dx -= lift * 30;
          dx += Math.sin(time * 3.0 + v * 4.0) * 8 * bottomPower * rightPower;
        }
        if (panel.index === 1) {
          const follow = liftPulse * bottomPower * Math.pow(u, 1.6);
          dy += follow * 24;
          dx -= follow * 8;
        }
        if (panel.index === 0) {
          dy *= 0.35;
          dx *= 0.35;
        }

        // めくれ上がり中は下から強い風を送る
        if (liftProgress > 0) {
          dy += liftProgress * 90 * bottomPower;
          dx += Math.sin(time * 4.0 + u * 5.0) * 12 * liftProgress * bottomPower;
        }

        arr[i] = x + dx;
        arr[i + 1] = y + dy;
        arr[i + 2] = base[i + 2];
      }
      pos.needsUpdate = true;
    });

    renderer.render(scene, camera);
  }
  animate();

  // リサイズ処理（デバウンス付き）
  const onResize = () => {
    if (!clothRunning || !renderedW() || !renderedH()) return;

    camera.left = -renderedW() / 2;
    camera.right = renderedW() / 2;
    camera.top = renderedH() / 2;
    camera.bottom = -renderedH() / 2;
    camera.updateProjectionMatrix();

    renderer.setSize(renderedW(), renderedH());

    buildPanels();
  }

  let resizeTimer;
  const ro = new ResizeObserver(() => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(onResize, 150); // タイマーIDを保持してデバウンスを効かせる
  });
  ro.observe($noren);

  // ===== 終了処理 =====
  const finishOpening = () => {
    $norenOpening.classList.add('is-finished'); // 白背景フェードアウト
    document.documentElement.style.overflow = '';
    try { sessionStorage.setItem(OPENING_STORAGE_KEY, '1'); } catch (e) {}

    setTimeout(() => {
      $body.classList.add('body-opening-finished');
      $norenOpening.classList.add('is-hidden');
      clothRunning = false;
      ro.disconnect();
      renderer.dispose();
      document.dispatchEvent(new CustomEvent('noren-opening:end'));
      topVisualSlide();
    }, FADE_DURATION);
  }

  // ===== のれん開き（中央から滴型に左右へ開くクリップパスアニメーション） =====
  // SVGのclipPath参照(url(#…))はFirefoxで動作しないケースがあるため、
  // clip-path: path('…') にピクセル座標を直接出力する方式にする（全ブラウザ共通動作）
  if (!reduceMotion) {
    // p: 0(閉：全面を覆う) → 1(全開) で左右2枚のパネル形状を生成
    // 内側エッジは「上端で垂直・下端で水平」の接線を持つ滴型のcubic bezier
    const buildClipAt = p => {
      const W = renderedW();
      const H = renderedH();
      const apexY = 101 - 123 * p;    // 閉：下に隠れる → 全開：上に抜ける
      const bottomY = 101 + 20 * p;   // 開口の下辺（常に画面外）
      const halfW = 80 * p;           // 開口の半幅
      const leftX = 50 - halfW;
      const rightX = 50 + halfW;
      const h = bottomY - apexY;

      // 100×100の論理座標 → 要素のピクセル座標へ変換して出力
      const fx = n => (n / 100 * W).toFixed(1);
      const fy = n => (n / 100 * H).toFixed(1);
      const aX = fx(50);
      const x0 = fx(-1), x1 = fx(101);
      const y0 = fy(-1);
      const cp1y = fy(apexY + h * 0.22);
      const cp2Lx = fx(leftX - halfW * 0.95);
      const cp2y = fy(apexY + h * 0.70);
      const cp2Rx = fx(100 - (leftX - halfW * 0.95));
      const aY = fy(apexY);
      const bY = fy(bottomY);

      // 左パネル
      let d = `M${x0} ${y0}L${aX} ${y0}L${aX} ${aY}`;
      d += `C${aX} ${cp1y} ${cp2Lx} ${cp2y} ${fx(leftX)} ${bY}`;
      d += `L${x0} ${bY}Z`;
      // 右パネル（ミラー）
      d += `M${x1} ${y0}L${aX} ${y0}L${aX} ${aY}`;
      d += `C${aX} ${cp1y} ${cp2Rx} ${cp2y} ${fx(rightX)} ${bY}`;
      d += `L${x1} ${bY}Z`;
      return d;
    };

    let lastClipP = 0;
    const applyClip = p => {
      lastClipP = p;
      if (!renderedW() || !renderedH()) return;
      const value = `path('${buildClipAt(p)}')`;
      $noren.style.clipPath = value;
      $noren.style.webkitClipPath = value;
    };

    applyClip(0);
    // リサイズでピクセル座標が変わるため現在のフレームを再適用
    const roClip = new ResizeObserver(() => {
      if (!clothRunning) { roClip.disconnect(); return; }
      applyClip(lastClipP);
    });
    roClip.observe($noren);

    const startOpening = () => {
      let t0 = null;

      const OVERSHOOT = 1.5;   // p=1で止めず、加速したまま画面外まで突き抜けさせる倍率
      const EASE_POWER = 4;    // 大きいほど後半の加速が強い（3→4で後半をさらに速く）
      const FADE_TIME = 400; // 終端までの残りこの時間(ms)から透過を開始し、終端でopacity 0
      const FADE_START = Math.max(1 - FADE_TIME / OPEN_DURATION, 0);
      const LIFT_TIME = 1200;  // 終端までの残りこの時間(ms)からのれん自体を上へ移動
      const LIFT_AMOUNT = 0.6; // 終端までに上昇する量（のれんの高さに対する割合）
      const LIFT_START = Math.max(1 - LIFT_TIME / OPEN_DURATION, 0);

      const step = now => {
        if (t0 === null) t0 = now;
        const t = Math.min((now - t0) / OPEN_DURATION, 1);
        const p = Math.pow(t, EASE_POWER) * OVERSHOOT; // 序盤じっと → 後半で一気に開き、そのまま突き抜ける

        liftProgress = Math.sin(t * Math.PI); // 開いている間だけ風を強める
        applyClip(p);

        if (t >= FADE_START) {
          // $norenOpening.style.transition = 'none'; // CSSのopacityトランジションと干渉させない
          // $norenOpening.style.opacity = Math.max(1 - (t - FADE_START) / (1 - FADE_START), 0);
        }

        if (t >= LIFT_START) {
          const lt = (t - LIFT_START) / (1 - LIFT_START);
          norenLiftY = lt * lt * PANEL_H * LIFT_AMOUNT; // 加速しながらのれん自体を上へ
        }

        if (t < 1) {
          requestAnimationFrame(step);
        } else {
          liftProgress = 0;
          finishOpening();
        }
      }
      requestAnimationFrame(step);
    }

    // window load が外部リソースで遅延・不発でも開始できるようにする
    const imagesReady = Promise.all(Array.from($imgs).map($img =>
      ($img.complete && $img.naturalWidth > 0)
        ? Promise.resolve()
        : new Promise(resolve => {
            $img.addEventListener('load', resolve, { once: true });
            $img.addEventListener('error', resolve, { once: true });
          })
    ));
    const pageReady = new Promise(resolve => {
      if (document.readyState === 'complete') {
        resolve();
      } else {
        window.addEventListener('load', resolve, { once: true });
        setTimeout(resolve, 4000); // 外部リソースが重くても最大4秒で開始
      }
    });
    Promise.all([imagesReady, pageReady]).then(() => setTimeout(startOpening, OPEN_DELAY));
  } else {
    // SVGなし・モーション軽減設定時は即終了
    finishOpening();
  }
}
